export const mutations = {
  SET_DATA_SEO(state, data) {
    state.dataSeo = { ...state.dataSeo, ...data };
  }
};

export const getters = {
  dataSeoExist: (state) => (name) => {
    return Object.keys(state.dataSeo).includes(name);
  },
  validName: (state) => (name) => {
    let [nameToCheck] = name?.split('___');
    return state.enablePages[nameToCheck];
  }
};

export const actions = {
  async LOAD_DATA_SEO({ commit, getters }, { name, lang }) {
    try {
      if (!getters.dataSeoExist(name)) {
        const { data } = await this.$axiosUtils.get(`seoview/?pagename=${name}___${lang}`);
        commit('SET_DATA_SEO', { [name]: data });
      }
    } catch (error) {
      console.error('SEO | LOAD_DATA_SEO:', error);
    }
  }
};

export const state = () => ({
  dataSeo: {},
  enablePages: {
    topics: 'topics',
    styles: 'styles',
    niches: 'niches',
    collections: 'collections',
    categories: 'categories',
    'about-us': 'about-us',
    'new-vexels': 'new-vexels',
    'privacy-policy': 'privacy-policy',
    'redeem-coupon': 'redeem-coupon',
    profile: 'profile',
    'profile-billing': 'profile-billing',
    'profile-billing-invoice-history': 'profile-billing',
    'profile-billing-payments': 'profile-billing',
    'profile-my-requests': 'profile-my-requests',
    'profile-my-requests-new': 'profile-my-requests-new',
    'profile-tools': 'profile-tools',
    'profile-tools-merch-digest': 'profile-tools-merch-digest',
    'profile-account': 'profile-account',
    'profile-cancellation': 'profile-cancellation',
    'profile-downloads': 'profile-downloads',
    'profile-favorites': 'profile-favorites',
    'profile-my-designs': 'profile-my-designs',
    'templates-mockup-generator': 'templates-mockup-generator',
    'templates-t-shirt-maker': 'templates-t-shirt-maker'
  }
});
